import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-guide-details-position-details',
  imports: [CommonModule, ReactiveFormsModule],
  standalone: true,
  template: `
    <div
      class="flex flex-col sm:flex-row gap-y-3 sm:gap-y-0 sm:gap-x-6 w-full"
      [formGroup]="positionDetails"
    >
      <div class="flex flex-col w-full sm:w-auto">
        <label for="time" class="mb-2 text-sm font-medium text-gray-700"
          >Stellzeit</label
        >
        <input
          id="time"
          type="time"
          formControlName="time"
          class="text-sm sm:text-xs w-full rounded-md border border-gray-300 py-2 px-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          placeholder="Select a time"
        />
      </div>

      <!-- Location Input -->
      <div class="flex flex-col w-full sm:w-auto">
        <label for="location" class="mb-2 text-sm font-medium text-gray-700"
          >Ort</label
        >
        <input
          id="location"
          type="text"
          formControlName="location"
          class="text-sm sm:text-xs w-full rounded-md border border-gray-300 py-2 px-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          placeholder="Ort eingeben..."
        />
      </div>
    </div>
  `,
  styles: ``,
})
export class GuideDetailsPositionDetailsComponent {
  @Input({ required: true }) positionDetails!: FormGroup;
}
